namespace app.legacy {

    export interface ILegacyFrameScope extends ng.IScope {
        api: {};
    }

    export class LegacyFrame implements ng.IDirective {

        public restrict: string = "A";
        public scope = {
            parentUrl: "=stfLegacyFrame",
            stateChangeRequest: "=stfLegacyFrameStateChangeRequest"
        };

        public static factory() {
            return (legacyCommunicationService: LegacyCommunicationService, $stateParams: ng.ui.IStateParamsService) => {
                "ngInject";
                return new LegacyFrame(legacyCommunicationService, $stateParams);
            };
        }

        public constructor(private legacyCommunicationService: LegacyCommunicationService, private $stateParams: ng.ui.IStateParamsService) {
            
        }

        public link(scope: ILegacyFrameScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
            let iframeElementContentWindow = () => {
                return (<HTMLIFrameElement>element[0]).contentWindow;
            };
            
            scope.$watch("parentUrl", (newVal) => {
                if (newVal) {
                    this.legacyCommunicationService.receiveStartedLoadingMessage(() => {
                        this.hideScroll();
                        iframeElementContentWindow().postMessage({"operation": "setParentUrl", "data": newVal + "/legacy/" + this.$stateParams["context"]}, "*");
                    });
                }
            });
            
            scope.$watch("stateChangeRequest.request", (newVal: any) => {
                if (newVal) {
                    iframeElementContentWindow().postMessage({"operation": "changeState", "data": newVal.url}, "*");
                }
            });
            
            scope.$on("legacy:callback", (event, data) => {
                iframeElementContentWindow().postMessage({"operation": "callback", "data": {id: data.id, data: data.data}}, "*");
            });
            
            scope.$on("$destroy", () => {
                this.showScroll();
            });
        }
        
        private hideScroll(): void {
            angular.element(document).find("[legacy-scroll-fix] > .ps-scrollbar-y-rail").css("display", "none");
            angular.element(document).find("[legacy-scroll-fix] > .ps-scrollbar-y-rail > .ps-scrollbar-y").css("display", "none");
        }
        
        private showScroll(): void {
            angular.element(document).find("[legacy-scroll-fix] > .ps-scrollbar-y-rail").css("display", "inherit");
            angular.element(document).find("[legacy-scroll-fix] > .ps-scrollbar-y-rail > .ps-scrollbar-y").css("display", "inherit");
        }

    }

    angular.module("app.legacy").directive("stfLegacyFrame", LegacyFrame.factory());

}